import type { WizardAnswers } from '@/context/WizardSessionContext';
import { markIntakeSubmitted } from '@/context/WizardSessionContext';
import { hasEntrepreneurProfile } from '@/lib/entrepreneur-profile';
import { submitIntake } from '@/lib/api/intakes';
import { answersToApi } from '@/lib/api/session-mapper';
import { acceptConsent, patchSessionSteps } from '@/lib/api/sessions';
import { JOURNEY_STEP } from '@/lib/journey-steps';
import { trackEvent } from '@/lib/analytics';

export type SubmitEntrepreneurIntakeResult = {
  monday_item_id: string;
};

export async function submitEntrepreneurIntake(
  sessionId: string,
  answers: WizardAnswers,
): Promise<SubmitEntrepreneurIntakeResult> {
  if (!hasEntrepreneurProfile(answers)) {
    throw new Error('PROFILE_INCOMPLETE');
  }

  await patchSessionSteps(sessionId, {
    current_step: JOURNEY_STEP.CONSENT,
    answers: answersToApi(answers),
  });
  await acceptConsent(sessionId, { consent_version: 'planning-submit-v1' });

  const result = await submitIntake(sessionId);
  if (!result.monday_item_id?.trim() || !result.monday_synced) {
    throw new Error('SUBMIT_FAILED');
  }

  trackEvent('intake_submitted', {
    monday_item_id: result.monday_item_id ?? undefined,
  });

  markIntakeSubmitted();

  return { monday_item_id: result.monday_item_id };
}
